var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8618 4.19501C11.1221 3.93493 11.5439 3.93504 11.8042 4.19501C12.0645 4.45536 12.0645 4.87802 11.8042 5.13837L5.13818 11.8044C4.87783 12.0647 4.45517 12.0647 4.19482 11.8044C3.93485 11.5441 3.93475 11.1223 4.19482 10.862L10.8618 4.19501Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 11.3337V5.33368H4.6665C4.29831 5.33368 3.99951 5.03488 3.99951 4.66669C3.99951 4.2985 4.29831 3.99969 4.6665 3.99969H11.3335C11.7015 3.99987 11.9995 4.29861 11.9995 4.66669V11.3337C11.9993 11.7016 11.7014 11.9995 11.3335 11.9997C10.9654 11.9997 10.6667 11.7017 10.6665 11.3337Z",
    fill: "currentColor"
  })));
};
export default SvgArrowUpRight;